export default function isTouchDevice() {
  return ('ontouchstart' in document.documentElement);
}
